import { render, staticRenderFns } from "./combination-item.vue?vue&type=template&id=82f3c67e"
import script from "./combination-item.vue?vue&type=script&lang=js"
export * from "./combination-item.vue?vue&type=script&lang=js"
import style0 from "./combination-item.vue?vue&type=style&index=0&id=82f3c67e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports